import * as React from 'react';

import Tooltip from 'Tooltip';

export default class Toggle extends React.Component {
  onClick(e) {
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  }

  render() {
    let toggleLabelClass = 'toggle-label';
    let toggleClass = this.props.toggleClass || '';
    let toggleSwitchMargin = this.props.toggleSwitchMargin || '';
    let toggleSwitchColor = this.props.toggleSwitchColor || '';
    let onChangeEvent = this.props.onChange || function() {};

    if (this.props.disabled) {
      toggleLabelClass += ' toggle-label-disabled';
    }

    let toggleChildren = [
      <div
        className={
          this.props.alignment
            ? 'toggle-slider ' + this.props.alignment
            : 'toggle-slider align-left'
        }
        key="toggleDive"
        onClick={(e) => this.onClick(e)}
      >
        <input
          id={this.props.id}
          className="toggle-slider-checkbox"
          type="checkbox"
          disabled={this.props.disabled}
          checked={this.props.checked}
          onChange={onChangeEvent}
          key="toggleInput"
        />
        <label
          className={`toggle-slider-label ${toggleClass}`}
          htmlFor={this.props.id}
          key="toggleSliderLabel"
        >
          <div
            className={`toggle-slider-inner ${toggleSwitchMargin}`}
            key="toggle-slider-inner"
          />
          <div
            className={`toggle-slider-switch ${toggleSwitchColor}`}
            key="toggle-slider-switch"
          />
        </label>
      </div>,
    ];

    if (this.props.label) {
      toggleChildren.push(
        <label
          htmlFor={this.props.id}
          className={toggleLabelClass}
          onClick={(e) => this.onClick(e)}
          key="toggleLabel"
        >
          {this.props.label}
        </label>
      );
    }

    if (this.props.children) {
      toggleChildren.push(this.props.children);
    }

    if (this.props.tooltip) {
      let tooltipProps = this.props.tooltip;
      tooltipProps.key = 'tooltip';
      toggleChildren.push(<Tooltip {...tooltipProps} />);
    }

    return (
      <div
        className={
          'settings-cnt clearfix' +
          (this.props.className ? ` ${this.props.className}` : '')
        }
      >
        {toggleChildren}
      </div>
    );
  }
}
